export default __webpack_public_path__ + "static/media/trash.2ca162a4.svg";